var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLead = function SvgLead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 110-18 9 9 0 010 18zm0-1.636a7.364 7.364 0 100-14.728 7.364 7.364 0 000 14.728zM16.245 8.79l-1.734 5.203a.818.818 0 01-.518.518L8.79 16.245a.818.818 0 01-1.035-1.035l1.734-5.203a.818.818 0 01.518-.518l5.203-1.734a.818.818 0 011.035 1.035zm-5.333 2.122l-1.087 3.263 3.263-1.087 1.087-3.263-3.263 1.087z"
  })));
};
export default SvgLead;